export default __webpack_public_path__ + "static/media/toolr_time_clock_logo_noslug_dark_v1.7c65229c.svg";